module.exports = __webpack_public_path__ + "img/h_2.d91999c8.png";